const fmt = (val, pad = 2) => String(val).padStart(pad, '0');

export const formatTime = (ms = 0) => {
  const totalSeconds = Math.floor(ms / 1000);

  const secondsInMinute = 60;
  const secondsInHour = secondsInMinute * 60;

  const hours = Math.floor(totalSeconds / secondsInHour);
  const minutes = Math.floor((totalSeconds % secondsInHour) / secondsInMinute);
  const seconds = totalSeconds % secondsInMinute;

  const timeParts = [...(hours ? [fmt(hours)] : []), fmt(minutes), fmt(seconds)];

  return timeParts.join(':');
};
